import { Controller } from "@hotwired/stimulus"

// Drives the per-item RMA resolution editor. The type dropdown controls everything: choosing "exchange"
// reveals the variant picker (an exchange needs a target variant) and waits for a variant to be picked
// before submitting; choosing any other type hides the picker and submits immediately. Fields are
// associated (via the HTML `form=` attribute) with a standalone form outside the "Verify RMA" form.
// Submitting does a full-page redirect, so first warn if the Verify RMA form has unsaved edits
// (quantities, reasons, newly added items) that would be discarded.
export default class extends Controller {
  static targets = ["type", "variant"]

  typeChanged() {
    const isExchange = this.typeTarget.value === "exchange"
    this.variantTarget.classList.toggle("hidden", !isExchange)
    // For exchange, wait until a variant is chosen (variantChanged submits). For any other type, submit now.
    if (!isExchange) this.submit()
  }

  variantChanged() {
    this.submit()
  }

  submit() {
    const surroundingForm = this.element.closest("form")
    const dirtyController =
      surroundingForm &&
      this.application.getControllerForElementAndIdentifier(surroundingForm, "dirty-form")

    if (
      dirtyController &&
      !dirtyController.confirmDiscard(
        "This return has unsaved changes (quantities, reasons, or newly added items). Applying this " +
          "resolution change reloads the page and discards them. Continue?"
      )
    ) {
      return
    }

    this.typeTarget.form?.requestSubmit()
  }
}
